import React, {useEffect} from 'react'

export default function PhonePinSignin(props) {
    const [values, setValues] = React.useState({
      phone_number: '',
      pin: '',
      showPin: false,
    });

    useEffect(() => {
      props.handleDataChange('phone', values);
    }, [values]);
    
    const handleChange = (property) => (event) => {
        let value = event.target.value
        let id = event.target.id;
        singleErrorCheck(id, value);
        if(id === 'phone_number') {
          value = value.split('-').join('');
          if(!isNumber(value)) {return}
          if(value.length >= 16) {
            return
          }
          value = value.length < 11 ? formatPhoneNumber(value) : value;
        }
        props.handleDataChange('phone', values);
        setValues({ ...values, [property]: value });
    };

    const handleClickShowPin = () => {
    setValues({ ...values, showPin: !values.showPin });
    };

    let errorStyle = (id, property, style) => {document.getElementById(`${id}`).style[property] = style}

    let errorTarget = (id, value) => {
        let errors = false;
        // let errorStyle = (style) => {document.getElementById(`${id}-container`).style.borderBottom = style}
        if(value.length < 1){
          errorStyle(`${id}-container`, 'border', '1px solid #ef4b4b')
          errors = true;
        } else {
          errorStyle(`${id}-container`, 'border', '')
          // errorStyle('');
        }
        return errors;
    }

    let formatPhoneNumber = (phoneNumberString) => {
      phoneNumberString = phoneNumberString.split('-').join('');
      let newString = phoneNumberString.split('');
      if(newString.length > 3) {
        newString.splice(3, 0, '-');
        if(newString.length > 7) {
          newString.splice(7, 0, '-');
        }
      };
      newString = newString.join('');
      return newString
    }

    const isNumber = (value) => {
        let validNumbers = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
        for(let i = 0; i < value.length; i++) {
          if(!validNumbers.includes(value[i])) {
            return false;
          }
        }
        return true;
      }

    const singleErrorCheck = (target, value) => {
        errorTarget(target, value);
    }
    return (
        <form className="col s12">
            <div className="row get-phone-number">
                <div className="input-field col s12 userCardNumber" id="phone_number-container">
                    <input id="phone_number" type="tel" className="validate" pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}" onChange={handleChange('phone_number')} value={values.phone_number}/>
                    <label htmlFor="phone_number">Phone Number</label>
                </div>
            </div>
            <div className="row get-pin">
                <div className="input-field col s12 userCardNumber" id="pin-container">
                    <input id="pin" type={values.showPin ? "text" : "password"} className="validate" onChange={handleChange('pin')}/>
                    <label htmlFor="pin">Pin</label>
                    <span className="show-hide-pin waves-effect" onClick={handleClickShowPin}><i className={`las la-eye${values.showPin ? '' : '-slash'}`}></i></span>
                </div>
            </div>
      </form>
    )
}
